module.exports = __webpack_public_path__ + "img/en.c39480d5.svg";